import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import { HStack, VStack } from 'tio-ui/components/layout';
import LandingInfoCard from 'tio-employee/components/landing/info-card';
import Text from 'tio-ui/components/text';
import { PhChatsCircle, PhLifebuoy, PhQuestion, PhUsersThree } from 'ember-phosphor-icons';

<template>
  <VStack class="gap-6">
    <LandingInfoCard
      @icon={{PhChatsCircle}}
      @iconColor="violet"
      @title={{t "coaching.about.ask_our_coaches"}}
    >
      <HStack>
        <VStack>
          <Text @tag="p" class="app-rich-text">
            {{t "coaching.about.coaches_info_1"}}
          </Text>
          <Text @tag="p">
            {{t "coaching.about.coaches_info_2"}}
          </Text>
        </VStack>
        <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
          <LinkTo
            @route="authenticated.repaying-student-debt.coaching.schedule"
            class="text-lg app-text-link app-text-link--inline"
          >
            {{t "coaching.about.ask_coaches_link_text"}}
          </LinkTo>
        </div>
      </HStack>
    </LandingInfoCard>

    <LandingInfoCard
      @icon={{PhLifebuoy}}
      @iconColor="green"
      @title={{t "coaching.about.get_support"}}
    >
      <HStack>
        <VStack>
          <Text @tag="p">
            {{t "coaching.about.support_info_pt1"}}
            {{t "coaching.about.support_info_pt2" htmlSafe=true}}
            {{t "coaching.about.support_info_pt3"}}
          </Text>
        </VStack>
        <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
          <LinkTo
            @route="authenticated.contact-us"
            class="text-lg app-text-link app-text-link--inline"
          >
            {{t "coaching.about.chat_link_text"}}
          </LinkTo>
        </div>
      </HStack>
    </LandingInfoCard>

    <LandingInfoCard
      @icon={{PhQuestion}}
      @iconColor="amber"
      @title={{t "coaching.about.previous_questions"}}
    >
      <HStack>
        <VStack>
          <Text @tag="p">
            {{t "coaching.about.questions_info"}}
          </Text>
        </VStack>
        <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
          <a
            href="https://www.tuition.io/blog/"
            class="text-lg app-text-link app-text-link--inline"
          >
            {{t "coaching.about.coach_blog_link_text"}}
          </a>
        </div>
      </HStack>
    </LandingInfoCard>

    <LandingInfoCard
      @icon={{PhUsersThree}}
      @iconColor="blue"
      @title={{t "coaching.about.learn_about_coaches"}}
    >
      <VStack @collapsed={{true}}>
        <Text @tag="p">
          {{t "coaching.about.learn_coaches_info_1"}}
        </Text>
        <Text @tag="p">
          {{t "coaching.about.learn_coaches_info_2"}}
        </Text>
        <Text @tag="p">
          {{t "coaching.about.learn_coaches_info_3"}}
        </Text>
      </VStack>
    </LandingInfoCard>
  </VStack>
</template>
